export const phoneReplaceFunc = (phone) => {
  const phoneArr = phone.split('');
  const phoneArrCopy = phoneArr.slice();
  phoneArrCopy.splice(6, 5, '*****');
  return phoneArrCopy;
};

export const cleanPhone = (phone) => {
  return phone?.replace(/\D/g, '');
};